import Cookies from 'js-cookie';
import { getProdConfig } from '../../config/locale-config/production/productionConfig';
import { getSandboxConfig } from '../../config/locale-config/sandbox/sandboxConfig';
import { extractLocale } from './extract-locale';
import { IChatConfigData } from '../../types/app-interfaces';
import { caDevsConfig, sitConfig, stConfig, unifiedSandboxConfig } from '../../config/locale-config/test-config';

const COOKIE_VALUE = 'chatAnywhere_cookie';
const COOKIE_NAME = 'ca-test';

const SF_CONFIG_COOKIE_NAME = 'ca-config';

let cachedConfig: IChatConfigData;

export const getCAEnv = (): 'production' | 'sandbox' => {
  if (Cookies.get(COOKIE_NAME) === COOKIE_VALUE) return 'sandbox';
  if (window.location.href.includes('localhost')) return 'sandbox';
  if (window.location.href.includes('staging')) return 'sandbox';
  return 'production';
};

export const initChatConfig = (locale?: string) => {
  const updatedLocale = extractLocale(locale);
  /** Sandbox -> when cookie is set or in localhost, else production */
  const env = getCAEnv();
  /** To support multiple orgs of SF */
  const sfConfigCookie = Cookies.get(SF_CONFIG_COOKIE_NAME);
  console.info('sfConfigCookie', sfConfigCookie);
  if (sfConfigCookie === 'sit') {
    cachedConfig = sitConfig;
  } else if (sfConfigCookie === 'st') {
    cachedConfig = stConfig;
  } else if (sfConfigCookie === 'cadevs') {
    cachedConfig = caDevsConfig;
  } else if (sfConfigCookie === 'unifiedsbx') {
    cachedConfig = unifiedSandboxConfig;
  } else {
    cachedConfig = env === 'production' ? getProdConfig(updatedLocale) : getSandboxConfig(updatedLocale);
  }
};

export const getChatConfig = (locale?: string): IChatConfigData => {
  /** If config already set, return it */
  if (cachedConfig) {
    return cachedConfig;
  }
  const updatedLocale = extractLocale(locale);
  const env = getCAEnv();

  const config = env === 'production' ? getProdConfig(updatedLocale) : getSandboxConfig(updatedLocale);
  return config;
};
